<mat-card appearance="outlined" class="card pointer-default">
    <mat-card-header>
        <mat-card-title-group>
            <mat-card-title>{{headerText}}
                <div *ngIf="colour == 'Green'" class="badge badge-pill green-background">
                    {{status}}
                </div>
                <div *ngIf="colour == 'Grey'" class="badge badge-pill grey-background">
                    {{status}}
                </div>
                <div *ngIf="colour == 'Orange'" class="badge badge-pill orange-background">
                    {{status}}
                </div>
                <div *ngIf="colour == 'Blue'" class="badge badge-pill blue-background">
                    {{status}}
                </div>
            </mat-card-title>  
            <mat-card-subtitle >
                <div *ngIf="isLoading"  class="center-container">
                    <mat-spinner [diameter]="60" ></mat-spinner>
                </div>
                <div class="web-row" *ngIf="consolidated && !isLoading">
                    <div class="column">
                        <div class="t1 status-item-text">Number of PI's</div>
                        <div class="t1 bold status-item-text">{{numberPiS}}</div>
                    </div>
                    <div class="spacer"></div>
                    <div class="column">
                        <div class="t1 bold status-item-text">
                            <div  class="grayDot"></div>
                            {{calcNotStarted}}% Not Started
                        </div>
                        <div class="t1 bold status-item-text">
                            <div  class="orangeDot"></div>
                            {{calcInProgress}}% In Progress
                        </div>
                        <div class="t1 bold status-item-text">
                            <div  class="blueDot"></div>
                            {{calcCounted}}% Counted
                        </div>
                        <div class="t1 bold status-item-text">
                            <div  class="greenDot"></div>
                            {{calcSubmitted}}% Submitted
                        </div>
                    </div>
                </div>
                <div class="column" *ngIf="!consolidated  && !isLoading">
                    <div class="t1 status-item-text">Consolidated Number</div>
                    <div class="t1 bold status-item-text">{{piNumber}}</div>
    
                    <div class="t1 status-item-text">Planned Count</div>
                    <div class="t1 bold status-item-text">{{plannedCountDate}}</div>
    
                    <div class="t1 status-item-text">Type</div>
                    <div class="t1 bold status-item-text">{{type}}</div>
                </div>         
            </mat-card-subtitle>
           
            <div *ngIf="!isLoading && consolidated" class="chart"  >
                <apx-chart    [chart]="pieChartOptions.chart" 
                [legend]="pieChartOptions.legend" 
                [labels]="pieChartOptions.labels" 
                [responsive]="pieChartOptions.responsive" 
                [series]="pieChartOptions.series"
                [colors]="pieChartOptions.colors"
                [dataLabels]="pieChartOptions.dataLabels"></apx-chart>
            </div>
        </mat-card-title-group>
    </mat-card-header>
</mat-card>